export default __webpack_public_path__ + "static/media/tick.74a1c0e8.svg";